var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadbutton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    fill: "#1C486B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 29.834V32.1673C14.6641 33.456 15.7087 34.5007 16.9974 34.5007H30.9974C32.2861 34.5007 33.3307 33.456 33.3307 32.1673V29.834",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 29.834V32.1673C14.6641 33.456 15.7087 34.5007 16.9974 34.5007H30.9974C32.2861 34.5007 33.3307 33.456 33.3307 32.1673V29.834",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 20.4993L23.9974 14.666L29.8307 20.4993",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1641 20.4993L23.9974 14.666L29.8307 20.4993",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 14.666V28.666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9974 14.666V28.666",
    stroke: "white",
    strokeOpacity: 0.1,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadbutton);
export default __webpack_public_path__ + "static/media/uploadbutton.e82cc68d6fdb970113670ec8bf07e138.svg";
export { ForwardRef as ReactComponent };